/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-10-27 14:30:44
 * @Description:
 */
export default [
  //用户
  {
    path: "/main", //用户操作页面
    name: "main",
    component: () => import("../views/user/main.vue"),
  },
  {
    path: "/individualUser", //代理商个人信息
    name: "individualUser",
    component: () => import("@/views/user/individualUser.vue"),
  },
  {
    path: "/orgUser", //代理商个人信息
    name: "orgUser",
    component: () => import("@/views/user/orgUser.vue"),
  },
  {
    path: "/changePwd", //修改密码
    name: "changePwd",
    component: () => import("@/views/user/changePwd.vue"),
  },
  {
    path: "/feedback", //问题反馈
    name: "feedback",
    component: () => import("@/views/user/feedback.vue"),
  },
  {
    path: "/sendSms", //发送验证码
    name: "sendSms",
    component: () => import("@/views/user/sendSms.vue"),
  },
  {
    path: "/changePayPwd", //修改支付密码
    name: "changePayPwd",
    component: () => import("@/views/user/changePayPwd.vue"),
  },
  {
    //用户列表
    path: "/userList",
    name: "userList",
    component: () => import("@/views/user/userList.vue"),
  },
  {
    //批量激活
    path: "/activationConfirm",
    name: "activationConfirm",
    component: () => import("@/views/user/activationConfirm.vue"),
  },
  {
    //用户详情
    path: "/userDetail",
    name: "userDetail",
    component: () => import("@/views/user/userDetail.vue"),
  },
  {
    //用户补换卡
    path: "/changeCard",
    name: "changeCard",
    component: () => import("@/views/user/changeCard.vue"),
  },
  {
    //完善资料
    path: "/perfect",
    name: "perfect",
    component: () => import("@/views/user/perfect.vue"),
  },
  {
    //设置语音服务期
    path: "/voiceservice",
    name: "voiceservice",
    component: () => import("@/views/user/voiceservice.vue"),
  },
  {
    //未绑定单位用户列表
    path: "/unbounduser",
    name: "unbounduser",
    component: () => import("@/views/user/unbounduser.vue"),
  },
  {
    //绑定设备
    path: "/bindingdevice",
    name: "bindingdevice",
    component: () => import("@/views/user/bindingdevice.vue"),
  },
];
